/* eslint-disable jsx-a11y/img-redundant-alt */
import { useCallback, useEffect, useRef, useState } from "react";
import { Button, Image } from 'antd';
import classNames from 'classnames';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import MonogramIcon from "assets/images/mongram.jpg";
import {
  EcommerceFlow,
  POSFlow,
  shortenValue,
  toastMessage,
  useGlobalMerchant,
} from "utils/helper";
import { baseImageURL } from 'utils/env';
import { getMerchantEcommercePathway } from "apiServices/app";
import { useBasket } from "containers/POSContainer/constant";
import { onStoreData } from 'utils/checkout';
import { useStyles } from './style';

const CBasketItemComponent = ({
  flowName,
  setShowShippingLayout,
  setShowSideBasket,
  googleReCaptchaProps
}: any) => {
  const { itemList, addToBasket, removeFromItem, removeFromBasket } = useBasket();
  const { globalMerchantId, globalMerchantCurrency, setEcommerceContent, ecommerceContent, setPaymentIframeURL } = useGlobalMerchant();
  const [merchantId, setMerchantId] = useState("");
  const [titleName, setTitleName] = useState("");
  const [onBtnLoader, setOnBtnLoader] = useState(false);
  const classes = useStyles();

  const totalAmounts = itemList.map((item: any) => { return item.qty * item.product.price; });
  const grandTotal = totalAmounts.reduce((acc: any, amount: any) => acc + amount, 0);

  const handlePlusAction = (productId: string, product: any) => { addToBasket(product); };

  const handleMinusAction = (productId: string, product: any) => {
    itemList.map((product: any) => {
      if (product.product.product_id === productId) { product.qty > 1 ? removeFromItem(productId) : removeFromBasket(productId); }
    });
  };

  const onErrorCall = (getErrorMessage: any) => {
    if (getErrorMessage == "Failed reCAPTCHA verification") {
      getToken(itemList, grandTotal, merchantId, globalMerchantCurrency);
    } else {
      toastMessage(getErrorMessage);
      setOnBtnLoader(false);
    }
  }

  const onCheckout = () => {
    const getPathname = window.location.pathname;
    if (getPathname === "/order") {
      toastMessage("Coming Soon");
    } else if (grandTotal !== 0 && Object.keys(ecommerceContent).length > 0) {
      setOnBtnLoader(true);
      if (titleName === POSFlow) {
        getToken(itemList, grandTotal, merchantId, globalMerchantCurrency);
      } else if (ecommerceContent.shipping_address == 1) {
        setShowShippingLayout(true);
        setShowSideBasket(false);
      } else if (ecommerceContent.shipping_address == 0) {
        getToken(itemList, grandTotal, merchantId, globalMerchantCurrency);
      }
    }
  };

  function getPathType(pathname: any) {
    if (pathname.startsWith("/pos/")) {
      return POSFlow;
    } else if (pathname.startsWith("/")) {
      return EcommerceFlow;
    } else {
      return "";
    }
  }

  const onGetEcommerceData = (getUserPathanme: any) => {
    try {
      getMerchantEcommercePathway(getUserPathanme)
        .then((response) => {
          const responseData = response.data || response;
          if (responseData !== null && responseData.success !== false) {
            setMerchantId(responseData[0].merchant_id);
            setEcommerceContent(responseData);
          }
        })
        .catch((error) => { console.log(error); });
    } catch (error: any) { }
  };

  const getToken = useCallback(async (getItemList: any, getTotalAmount: any, getMerchantId: any, getMerchantCurrency: any) => {
    if (googleReCaptchaProps && googleReCaptchaProps.executeRecaptcha) {
      try {
        const _token = await googleReCaptchaProps.executeRecaptcha("homepage");
        onStoreData(getItemList, getTotalAmount, getMerchantId, getMerchantCurrency, titleName, setOnBtnLoader, _token, onErrorCall, setPaymentIframeURL);
      } catch (error) { console.error('Error while executing recaptcha:', error); }
    } else { console.error('googleReCaptchaProps.executeRecaptcha is not available.'); }
  }, [googleReCaptchaProps]);

  useEffect(() => {
    const pathname = window.location.pathname;
    if (pathname === "/order") {
      setTitleName(EcommerceFlow);
      globalMerchantId && setMerchantId(globalMerchantId);
    } else {
      const orderType = getPathType(pathname);
      setTitleName(orderType);
      const parts = pathname.split("/");
      const pathway = parts[parts.length - 1];
      onGetEcommerceData(pathway);
    }
  }, []);

  return (
    <>
      <div className={classNames(classes.basketItemWrapper)}>
        {itemList.map((items: any) => (
          <div className="basketConProWrapper" key={items.product.product_id}>
            <div className="basketItem">
              <div className="basketItemPic">
                <Image
                  src={items.product.img !== null ? `${baseImageURL}${items.product.img}` : MonogramIcon}
                  alt="product image"
                  preview={false}
                />
              </div>
              <div className="basketItemContent">
                <span className="subInnerHeadingPara colorBlack"> {items.product.product_name} </span>
                <span className="subInnerHeading"> {shortenValue(items.qty * items.product.price)} {globalMerchantCurrency} </span>
              </div>
              <div className="basketItemBtnWrapper">
                {items.product.qty == items.qty ? <Button disabled>+</Button> : <Button onClick={() => handlePlusAction(items.product.product_id, items.product)}>+</Button>}
                <span className="subInnerHeadingPara">{items.qty}</span>
                {items.qty == 1 ? <Button disabled>-</Button> : <Button onClick={() => handleMinusAction(items.product.product_id, items.product)}>-</Button>}
              </div>
            </div>
            <span className="basketConProTitle">Available Quantity: {items.product.qty}</span>
          </div>
        ))}
      </div>
      <div className={classNames(classes.basketCheckoutWrapper)}>
        <div className={ecommerceContent.shipping_address === 0 ? "basketAmountWrapper m0" : "basketAmountWrapper"}>
          <p className="subInnerHeadingPara">Total Amount:</p>
          <p className="subHeading m0">{shortenValue(grandTotal)} {globalMerchantCurrency}</p>
        </div>
        <Button type="primary" className="commonButton" onClick={() => !onBtnLoader && onCheckout()} disabled={grandTotal === 0}>
          {onBtnLoader ? "Loading..." : "Checkout"}
        </Button>
      </div>
    </>
  );
};

export default withGoogleReCaptcha(CBasketItemComponent);
